<template>
  <llp-page
    id="datatable-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card m-2 m-lg-3">
          <div class="card-body">
            <div class="row p-0 align-items-center">
              <div class="col mt-4">
                <h5>{{ this.bbpsServces.category_name }}</h5>
              </div>
              <div
                class="col-lg-3 col-md-6 col-sm-6 d-flex justify-content-end add-btn"
              >
                <llp-button
                  :load-spinner="showaddadminSpinner"
                  classNames="btn-secondary d-none d-sm-block new-btn"
                  @click="BackToBBPSServices"
                >
                  Back To Categories
                </llp-button>
                <llp-button
                  :load-spinner="showaddadminSpinner"
                  classNames="btn-secondary d-block d-sm-none new-btn"
                  @click="BackToBBPSServices"
                >
                  Go Back
                </llp-button>
              </div>
            </div>

            <!-- Search Form -->
            <form ref="searchForm" class="d-grid table-data" @submit.prevent="">
              <div class="row mt-5">
                <div class="col-lg-4 col-md-7 col-sm-6 mt-1">
                  <h6>Operators:</h6>
                  <Dropdown
                    v-model="selectedService"
                    :options="filteredServices"
                    optionLabel="name"
                    placeholder="Please select an operator"
                    class="form-control select-dropdown bbps-service-dropdown mobile-optimized-dropdown"
                    @change="selectService(selectedService)"
                    :loading="showOperatorsSpinner"
                    filter
                    filterBy="name"
                  >
                    <template #value="slotProps">
                      <div
                        v-if="slotProps.value"
                        class="flex align-items-center"
                      >
                        <div class="bbps-options text-truncate">
                          {{ slotProps.value.name }}
                        </div>
                      </div>
                      <span v-else>{{ slotProps.placeholder }}</span>
                    </template>

                    <template #option="slotProps">
                      <div class="flex align-items-center">
                        <div class="dropdown-option-text">
                          {{ slotProps.option.name }}
                        </div>
                      </div>
                    </template>
                  </Dropdown>
                </div>
              </div>
              <div class="row mt-5" v-if="selectedService">
                <div class="col-lg-4 col-md-8 col-sm-12">
                  <h6 class="fw-bold">{{ selectedService.name }}:</h6>
                  <div class="card p-4">
                    <div
                      v-if="showOperators"
                      class="col-lg-11 col-md-8 col-sm-12"
                    >
                      <div
                        v-for="(field, index) in getFields(selectedService)"
                        :key="index"
                      >
                        <llp-label :for="field.name" class="mt-2"
                          >{{ field.label }}:</llp-label
                        >
                        <llp-input
                          v-if="field"
                          v-model="stoaredValue[field.name]"
                          :placeHolder="field.placeHolder"
                          :pattern="field.regex"
                        ></llp-input>
                      </div>
                      <div v-if="selectedService.viewbill == 0">
                        <llp-label class="mt-2">Amount</llp-label>
                        <llp-input v-model="payAmount" id="payAmountId">
                        </llp-input>
                      </div>
                    </div>
                    <div
                      class="col-lg-3 col-md-4 col-sm-12 mt-2"
                      v-if="showOperators"
                    >
                      <llp-button
                        v-if="selectedService.viewbill == 1"
                        classNames="btn-secondary new-btn"
                        @click="viewBill()"
                      >
                        View Bill
                      </llp-button>
                      <llp-button
                        :loadSpinner="payLoading"
                        v-else
                        classNames="btn-secondary new-btn"
                        @click="PayBill()"
                      >
                        Pay
                      </llp-button>
                    </div>
                    <Dialog
                      v-model:visible="showPaymentDialog"
                      header="Select Payment Method"
                      modal
                      :style="{ width: '90%', maxWidth: '45rem' }"
                      :breakpoints="{ '960px': '75vw', '641px': '90vw' }"
                      @hide="onHideDialog"
                    >
                      <div v-if="paymentLoading" class="loader-overlay">
                        <div class="spinner"></div>
                      </div>
                      <span
                        class="text-surface-500 dark:text-surface-400 block"
                      >
                        Choose how you'd like to pay:
                      </span>

                      <div class="row mt-2">
                        <div
                          class="col-6 mb-2"
                          v-for="method in paymentMethods"
                          :key="method.id"
                        >
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              :id="method.id"
                              :value="method.value"
                              v-model="selectedPaymentMethod"
                              name="paymentOption"
                              @change="handlePaymentMethodChange(method.value)"
                            />
                            <label
                              class="form-check-label ms-2"
                              :for="method.id"
                            >
                              {{ method.name }}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="row" v-if="this.paymentCharges">
                        <div class="col-3">
                          <p><strong>Amount:</strong></p>
                          <p><strong>Service Charge:</strong></p>
                        </div>
                        <div class="col-3">
                          <p>₹{{ paymentCharges.base_amount }}</p>
                          <p>₹{{ paymentCharges.charge_amount }}</p>
                        </div>
                      </div>
                      <div
                        v-if="
                          selectedPaymentMethod === 'Credit Card/Debit Card'
                        "
                      >
                        <h5>Card details:</h5>
                        <div class="row">
                          <div class="mb-2 col-lg-6 col-md-6 col-sm-12">
                            <llp-label>Card Number:</llp-label>
                            <llp-input
                              v-model="cardDetails.cardNumber"
                              class="w-100 mb-2"
                              placeholder="Enter card number"
                              @input="formatCardNumber"
                              :errors="validator.cardDetails.cardNumber.$errors"
                            ></llp-input>
                          </div>
                        </div>

                        <div class="row">
                          <div class="mb-2 col-lg-6 col-md-6 col-sm-6">
                            <llp-label>Name on card</llp-label>
                            <llp-input
                              v-model="cardDetails.cardHolderName"
                              class="w-100 mb-2"
                              :errors="
                                validator.cardDetails.cardHolderName.$errors
                              "
                            />
                          </div>
                        </div>
                      </div>

                      <div class="flex justify-end gap-2">
                        <button
                          class="btn btn-secondary"
                          :load-spinner="payloadSpinner"
                          @click="PayAmount"
                        >
                          Pay Now
                          <span v-if="paymentCharges?.total_payable"
                            >({{ paymentCharges.total_payable }})</span
                          >
                        </button>
                      </div>
                    </Dialog>
                    <div>
                      <div v-if="loading" class="bill-loader-container">
                        <div class="spinner"></div>
                      </div>
                      <div v-if="isBillViewed && billDetails" class="row">
                        <div>
                          <p class="bill-details">
                            Bill Amount :
                            <strong>{{ totalPrice }}</strong>
                          </p>
                          <p class="bill-details">
                            Bill Date :
                            <strong>{{ billDetails.billDate }}</strong>
                          </p>
                          <p class="bill-details">
                            Due Date :
                            <strong>{{ billDetails.dueDate }}</strong>
                          </p>
                          <p class="bill-details">
                            Customer Name :
                            <strong>{{ billDetails.customerName }}</strong>
                          </p>
                          <div class="col-lg-6">
                            <llp-button
                              classNames="btn-secondary new-btn"
                              @click="ProceedToPayment()"
                            >
                              Proceed to payment
                            </llp-button>
                          </div>
                        </div>
                      </div>
                      <div
                        v-else-if="isBillViewed && !billDetails && !loading"
                        class="row mt-3"
                      >
                        <div class="col-12">
                          <p class="text-danger fw-bold">
                            {{ this.errorMessage }}
                          </p>
                        </div>
                      </div>
                      <!-- <div v-if="payBilView">
                        <h2>Pay bill</h2>
                        <p class="bill-details">
                          Name of the biller :
                          <strong>Electricity Board</strong>
                        </p>
                        <p class="bill-details">
                          Mobile number :
                          <strong>+1234567890</strong>
                        </p>
                        <p class="bill-details">
                          Bill number :
                          <strong>123456789</strong>
                        </p>
                        <p class="bill-details">
                          Bill Date (dd/mm/yyyy) :
                          <strong>25/06/2025</strong>
                        </p>
                        <p class="bill-details">
                          Bill Due Date (dd/mm/yyyy) :
                          <strong>05/07/2025</strong>
                        </p>
                        <p class="bill-details">
                          B-Connect txn id:
                          <strong>TXN987654321</strong>
                        </p>
                        <p class="bill-details">
                          Registered mobile number:
                          <strong>+0987654321</strong>
                        </p>
                        <p class="bill-details">
                          Payment mode:
                          <strong>Credit Card</strong>
                        </p>
                        <p class="bill-details">
                          Payment channel:
                          <strong>Online</strong>
                        </p>
                        <p class="bill-details">
                          Bill amount:
                          <strong>150.00</strong>
                        </p>
                        <p class="bill-details">
                          Customer convenience fee:
                          <strong>5.00</strong>
                        </p>
                        <p class="bill-details">
                          Total:
                          <strong>155.00</strong>
                        </p>
                        <p class="bill-details">
                          Transaction date and time:
                          <strong>25/06/2025 14:30</strong>
                        </p>
                        <p class="bill-details">
                          Status:
                          <strong>Paid</strong>
                        </p>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import NetworkService from "@/services/network.service";
import Dropdown from "primevue/dropdown";
import Dialog from "primevue/dialog";
import useVuelidate from "@vuelidate/core";

import _ from "lodash";
import { cardValidation } from "@/validations/cardValidation";
import { formatCardNumber as formatCardNumberUtil } from "@/validations/cardFormatters";

// import axios from "axios";

export default {
  setup: () => ({ validator: useVuelidate() }),
  components: {
    Dropdown,
    Dialog,
  },
  data() {
    return {
      category_id: "",
      service_id: "",
      filteredServices: [],
      bbpsServces: "",
      searchQuery: "",
      selectedService: "",
      isBillViewed: false,
      showOperators: false,
      showOperatorsSpinner: false,
      billDetails: "",
      billResponse: "",
      totalPrice: "",
      loading: false,
      paymentLoading: false,
      stoaredValue: {},
      payloadSpinner: false,
      payLoading: false,
      showPaymentDialog: false,
      paymentCharges: null,
      paymentMethods: [],
      selectedPaymentMethod: "",
      userid: localStorage.getItem("User_id"),
      role_id: localStorage.getItem("role_id"),
      customerMobile: "",
      errorMessage: "",
      payBilView: false,
      paymentSuccessDetails: null,
      debouncedFetchCharges: null,
      lastCardDigits: "",
      lastCardHolderName: "",
      requestId: "",
      payAmount: "",
      cardDetails: {
        cardNumber: "",
        cardHolderName: "",
      },
    };
  },
  created() {
    this.category_id = this.$route.params.category_id;
    this.service_id = this.$route.params.serviceId;
    this.debouncedFetchCharges = _.debounce(this.fetchPaymentCharges, 2000);

    this.fetchBPPSDetails();
  },
  watch: {
    "cardDetails.cardNumber"() {
      this.tryFetchCharges();
    },
    "cardDetails.cardHolderName"() {
      this.tryFetchCharges();
    },
  },
  beforeUnmount() {
    if (this.debouncedFetchCharges) {
      this.debouncedFetchCharges.cancel();
    }
  },
  validations() {
    return cardValidation;
  },
  mounted() {
    const script = document.createElement("script");
    script.src = "https://sdk.cashfree.com/js/v3/cashfree.js";
    script.async = true;
    document.head.appendChild(script);
  },
  methods: {
    tryFetchCharges() {
      if (this.selectedPaymentMethod !== "Credit Card/Debit Card") return;
      const cleanNumber = this.cardDetails.cardNumber.replace(/\D/g, "");
      const holderName = this.cardDetails.cardHolderName?.trim();
      if (cleanNumber.length === 16 && holderName) {
        if (
          this.lastCardDigits !== cleanNumber ||
          this.lastCardHolderName !== holderName
        ) {
          this.lastCardDigits = cleanNumber;
          this.lastCardHolderName = holderName;
          this.debouncedFetchCharges("Credit Card/Debit Card", {
            card_number: cleanNumber,
          });
        }
      } else {
        this.paymentCharges = null;
      }
    },
    formatCardNumber() {
      this.cardDetails.cardNumber = formatCardNumberUtil(
        this.cardDetails.cardNumber
      );
      this.validator.cardDetails.cardNumber.$touch();
    },

    async fetchBPPSDetails() {
      this.showOperatorsSpinner = true;
      try {
        const response = await NetworkService.get(
          `/get-operators?category_id=${this.category_id}`
        );
        this.bbpsServces = response;
        const responseData = response.operators;
        this.filteredServices = responseData;
      } catch (error) {
        this.showOperatorsSpinner = false;
        this.$refs.toast.show(
          "No operators on selected category, Coming soon.",
          "error"
        );
      } finally {
        this.showOperatorsSpinner = false;
      }
    },
    handlePaymentMethodChange(methodValue) {
      console.log("Radio button changed:", methodValue);
      this.selectedPaymentMethod = methodValue;
      this.paymentCharges = null;
      this.cardDetails.cardNumber = "";
      this.cardDetails.cardHolderName = "";
      if (this.validator?.cardDetails?.cardNumber) {
        this.validator.cardDetails.cardNumber.$reset();
      }
      if (this.validator?.cardDetails?.cardHolderName) {
        this.validator.cardDetails.cardHolderName.$reset();
      }
      if (methodValue !== "Credit Card/Debit Card") {
        this.fetchPaymentCharges(methodValue);
      }
    },
    async fetchPaymentCharges(methodValue, extra = {}) {
      this.debouncedFetchCharges.cancel();
      if (!methodValue) return;

      this.loadingCharges = true;
      this.paymentLoading = true;
      try {
        const method = this.paymentMethods.find((m) => m.value === methodValue);
        if (!method) {
          throw new Error("Payment method not found");
        }
        const baseAmount = this.isBillViewed ? this.totalPrice : this.payAmount;
        // Using POST with request data
        const payload = {
          user_id: this.userid,
          method_type: methodValue,
          base_amount: baseAmount,
          ...extra,
        };
        const response = await NetworkService.getPaymentCharges(
          method.id,
          this.role_id,
          payload
        );

        if (response.success === false) {
          this.$refs.toast.show(
            response.message || "Unable to fetch payment charges",
            "error"
          );
          return;
        }

        this.paymentCharges = response;
        this.paymentLoading = false;
      } catch (err) {
        const msg =
          err?.response?.data?.message ||
          err.message ||
          "Failed to fetch charges";
        this.$refs.toast.show(msg, "error");
      } finally {
        this.loadingCharges = false;
        this.paymentLoading = false;
      }
    },
    selectService(service) {
      this.selectedService = service;
      this.showOperators = true;
      this.isBillViewed = false;
      this.billDetails = null;
      this.stoaredValue = {};
    },
    onHideDialog() {
      NetworkService.resetPaymentDialog(this);
    },
    getFields(service) {
      const fields = [];
      this.isBillViewed = false;

      if (service.displayname) {
        fields.push({
          name: "displayname",
          label: service.displayname,
          regex: "",
          placeHolder: service.displayname,
        });
      }

      Object.keys(service).forEach((key) => {
        if (key.startsWith("ad") && key.endsWith("_d_name")) {
          const fieldIndex = key.split("_")[0].replace("ad", "");
          const dName = service[key];
          const name = service[`ad${fieldIndex}_name`];
          const regex = service[`ad${fieldIndex}_regex`];
          if (dName && name) {
            fields.push({
              name: name,
              label: dName,
              regex: regex || "",
              placeHolder: name,
            });
          }
        }
      });

      return fields;
    },

    validateFields() {
      let valid = true;
      const fields = this.getFields(this.selectedService);
      for (let field of fields) {
        if (
          !this.stoaredValue[field.name] ||
          this.stoaredValue[field.name].trim() === ""
        ) {
          valid = false;
          this.$refs.toast.show(`${field.label} is required.`, "error");
          break;
        }
        if (field.regex && field.regex.trim() !== "") {
          const regex = new RegExp(field.regex);
          if (!regex.test(this.stoaredValue[field.name])) {
            valid = false;
            const expectedLength = field.regex.match(/\{(\d+)\}/);
            const requiredLength = expectedLength
              ? expectedLength[1]
              : "unknown length";
            this.$refs.toast.show(
              `${field.label} is invalid. Please enter exactly ${requiredLength} digits.`,
              "error"
            );
            break;
          }
        }
      }

      return valid;
    },

    async viewBill() {
      if (!this.validateFields()) {
        return;
      }
      this.loading = true;
      this.showOperators = false;
      this.payloadSpinner = true;
      const inputParamsArray = [];
      const fields = this.getFields(this.selectedService);
      for (const field of fields) {
        if (this.stoaredValue[field.name] !== undefined) {
          inputParamsArray.push({
            paramName: field.label,
            paramValue: this.stoaredValue[field.name],
          });
        }
      }
      if (this.stoaredValue[this.getFields(this.selectedService)[0]?.name]) {
        this.customerMobile =
          this.stoaredValue[this.getFields(this.selectedService)[0].name];
      }
      const mobileField = fields.find(
        (f) =>
          f.label === "Registered Mobile Number" || f.name === "mobileNumber"
      );
      if (mobileField && this.stoaredValue[mobileField.name]) {
        this.customerMobile = this.stoaredValue[mobileField.name];
      }
      const payload = {
        userId: this.userid,
        customerMobile: this.customerMobile,
        billerId: this.selectedService.operator_id,
        inputParams: {
          input: inputParamsArray,
        },
      };
      try {
        const response = await NetworkService.post("/fetch-bill-api", payload);
        if (response && response.data) {
          this.billDetails = response.data.data.billerResponse;
          (this.billResponse = response.data.data),
            (this.requestId = response.data.requestId);
          this.totalPrice = response.data.price;
        } else {
          this.billDetails = null;
          this.$refs.toast.show(
            response.message || "Unable to fetch bill.",
            "error"
          );
        }
      } catch (error) {
        if (error.error) {
          this.errorMessage = error.error;
          this.$refs.toast.show(this.errorMessage, "error");
        } else {
          this.$refs.toast.show(
            "Failed to fetch bill. Please try again.",
            "error"
          );
        }
      } finally {
        this.isBillViewed = true;
        this.loading = false;
        this.payloadSpinner = false;
      }
    },

    // async ProceedToPayment() {
    //   this.showPaymentDialog = true;
    //   this.paymentLoading = true;
    //   try {
    //     this.paymentMethods = await NetworkService.getPaymentMethods();
    //     if (this.paymentMethods.length === 0) {
    //       this.$refs.toast.show("No payment methods available", "warning");
    //     }
    //   } catch (error) {
    //     this.paymentLoading = false;
    //     this.$refs.toast.show("Unable to fetch the payment methods", "error");
    //   } finally {
    //     this.paymentLoading = false;
    //   }
    // },

    // To shown only upi payment method
    async ProceedToPayment() {
      this.showPaymentDialog = true;
      this.paymentLoading = true;
      try {
        const methods = await NetworkService.getPaymentMethods();
        // Only keep UPI method
        this.paymentMethods = methods.filter((method) => method.value == "UPI");

        if (this.paymentMethods.length === 0) {
          this.$refs.toast.show("No UPI payment methods available", "warning");
        }
      } catch (error) {
        this.$refs.toast.show("Unable to fetch the payment methods", "error");
      } finally {
        this.paymentLoading = false;
      }
    },
    async startCashfreeCheckout(paymentSessionId, orderId) {
      if (!window.Cashfree) {
        this.$refs.toast.show("Cashfree SDK not loaded", "error");
        return false;
      }
      const cashfree = window.Cashfree({ mode: "sandbox" });
      try {
        const result = await cashfree.checkout({
          paymentSessionId,
          redirectTarget: "_modal",
        });
        this.payloadSpinner = false;
        const message = result.paymentDetails.paymentMessage;
        console.log("message.......", message);

        if (message.includes("finished")) {
          try {
            this.paymentLoading = true;
            const res = await NetworkService.post(
              `get-cashfree-bill-payment-status/${orderId}`
            );
            console.log("res...........", res);

            this.$refs.toast.show(res.data.message);
            setTimeout(() => {
              this.paymentLoading = false;
              this.showPaymentDialog = false;
              this.$router.push({ name: "ThankYou" });
            }, 2000);
            //  setTimeout(()=>
            //  {
            //  this.$refs.toast.show(res.data.message);
            //  },3000)
            //   this.paymentLoading = false;
            //    this.showPaymentDialog = false;
          } catch (error) {
            this.paymentLoading = false;
            this.$refs.toast.show("Failed to fetch payment status", "error");
          }
        }
        return true;
      } catch (error) {
        this.payloadSpinner = false;
        this.$refs.toast.show(
          "An error occurred during payment. Please try again.",
          "error"
        );
        setTimeout(() => {
          this.$router.back();
        }, 3000);
        return false;
      }
    },

    async PayAmount() {
      console.log("pay amount ");

      if (!this.selectedPaymentMethod) {
        this.$refs.toast.show("Please select a payment method", "error");
        return;
      }
      if (this.selectedPaymentMethod === "Credit Card/Debit Card") {
        const isValid = await this.validator.$validate();
        if (!isValid) return;
      }

      this.payloadSpinner = true;
      try {
        const selectedMethod = this.paymentMethods.find(
          (method) => method.value === this.selectedPaymentMethod
        );

        const amountToPay =
          this.selectedService.viewbill == 1 ? this.totalPrice : this.payAmount;

        const paymentDetails = {
          input_params:
            this.selectedService.viewbill == 1
              ? this.billResponse.inputParams
              : this.stoaredValue,
          billerResponse:
            this.selectedService.viewbill == 1
              ? this.billResponse.billerResponse
              : {},
          fetch_bill_response:
            this.selectedService.viewbill == 1
              ? this.billResponse.additionalInfo
              : {},
          user_id: this.userid,
          base_amount: amountToPay,
          payment_method_id: selectedMethod.id,
          category_id: this.category_id,
          service_id: this.service_id,
          request_id: this.requestId,
          billerId: this.selectedService.operator_id,
          charge_amount: this.paymentCharges.charge_amount,
          amount: this.paymentCharges.total_payable,
          method_type: this.selectedPaymentMethod,
          charge_percent: this.paymentCharges.charge_percent,
        };

        const result = await NetworkService.PaymentService.initiate(
          `get-payment-gateways-for-pay`,
          selectedMethod.id,
          paymentDetails
        );
        console.log("result.......", result);
        if (
          result.selected_method === "auropay" &&
          result?.order?.paymentLink
        ) {
          window.location.href = result.order.paymentLink;
          return;
        }
        const paymentSessionId = result?.order?.data?.payment_session_id;
        const orderId = result?.order?.data?.order_id;
        if (paymentSessionId) {
          await this.startCashfreeCheckout(paymentSessionId, orderId);
        } else {
          throw new Error("No payment session ID received from server");
        }
      } catch (error) {
        this.payloadSpinner = false;
        const errorInfo = NetworkService.PaymentService.handleError(error);
        this.$refs.toast.show(errorInfo.message, "error");
      }
    },

    BackToBBPSServices() {
      this.$router.back();
    },
    // async PayBill() {
    //   if (!this.validateFields()) {
    //     return;
    //   }
    //   this.payloadSpinner = true;

    //     this.showPaymentDialog = true;
    //   this.payloadSpinner = false;
    //   // const details = {
    //   //   user_id: this.userid,
    //   //   pay_amount: this.payAmount,
    //   // };
    //   // try {
    //   //   const paymentResponse = await NetworkService.post(
    //   //     "get-payment-link",
    //   //     details
    //   //   );
    //   //   const responseData = paymentResponse.data.data;
    //   //   if (responseData.order_status && responseData.payment_session_id) {
    //   //     await this.startCashfreeCheckout(responseData.payment_session_id);
    //   //   } else {
    //   //     this.payloadSpinner = false;
    //   //     this.$refs.toast.show("Unable to start payment session", "error");
    //   //   }
    //   // } catch (error) {
    //   //   this.payloadSpinner = false;
    //   //   this.$refs.toast.show("An error occurred. Please try again.", "error");
    //   //   setTimeout(() => {
    //   //     this.$router.push("/services");
    //   //   }, 3000);
    //   // }
    // },

    async PayBill() {
      if (!this.validateFields()) return;
      if (this.selectedService.viewbill == 0) {
        if (
          !this.payAmount ||
          isNaN(this.payAmount) ||
          Number(this.payAmount) <= 0
        ) {
          this.$refs.toast.show("Please enter a valid amount to pay.", "error");
          return;
        }
      }
      this.showPaymentDialog = true;
      this.payLoading = true;
      try {
        const res = await NetworkService.get("payment-methods-for-pay");
        if (res.status && Array.isArray(res.data)) {
          this.paymentMethods = res.data.map((method) => ({
            id: method.id,
            name: method.payment_method,
            value: method.payment_method,
          }));
        } else {
          this.paymentMethods = [];
          this.$refs.toast.show("No payment methods available", "warning");
        }
      } catch (error) {
        this.$refs.toast.show("Unable to fetch the payment methods", "error");
      } finally {
        this.payLoading = false;
      }
    },
  },
};
</script>


 
